<div class="heading" (resize)="handleResize($event)">
  @if (canGoBack()) {
    <app-button2 appearance="secondary-ghost" size="s" aria-label="Go back" (click)="handleGoBack()">
      <app-icon name="chevron-left" />
    </app-button2>
  }

  <div class="meta">
    <app-message-connections [message]="message" />
  </div>

  <!-- The icons with the mailbox badge under them, right-aligned (the prototype's header action column). -->
  <div class="heading-end">
    <div class="icons print:!hidden">
      <!-- [MUST-002] 'Bug' debug quick-action hidden per task; uncomment to re-enable
      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="bug"
        [active]="selectedTab === 'debug'"
        matTooltip="Debug"
        (onClick)="selectedTab = 'debug'"
      />
      -->

      <!-- TODO: Figure out why we need this -->
      <!--    <stch-quick-action-->
      <!--      *ngIf="!contracted"-->
      <!--      appearance="sapphire-toggle"-->
      <!--      size="m"-->
      <!--      icon="sapphire-attachment"-->
      <!--      matTooltip="Reply"-->
      <!--      [disabled]="!message?.id"-->
      <!--    />-->

      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-reply"
        matTooltip="Reply"
        [disabled]="!message?.id"
        (click)="forward('reply')"
      />

      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-reply-all"
        matTooltip="Reply to all"
        [disabled]="!message?.id"
        (click)="forward('replyAll')"
      />

      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-mail-forward"
        matTooltip="Forward"
        [disabled]="!message?.id"
        (click)="forward('forward')"
      />

      <ng-container *ngComponentOutlet="workspaceComponents['app-item-workspace-chip']; inputs: workspaceChipInputs" />
      @if (handoverTenantId) {
        <app-button2
          appearance="secondary"
          size="m"
          [height]="32"
          rounding="lg"
          data-handover-anchor
          [ariaLabel]="handoverControl.accessibleName()"
          [ariaHaspopup]="'dialog'"
          [disabled]="!handoverCanAssign || handoverControl.busy()"
          [attr.title]="handoverCanAssign ? null : 'Requires edit access'"
          [ariaDescribedBy]="
            !handoverCanAssign
              ? handoverControl.ids.title + '-edit'
              : handoverControl.busy()
                ? handoverControl.ids.busy
                : null
          "
          (click)="handoverCanAssign && handoverControl.openAssign()"
        >
          <app-icon name="sapphire-user-plus" size="m" />
          {{ handoverControl.buttonLabel() }}
          <app-icon name="sapphire-chevron-down" size="s" />
          <span class="sr-only" [id]="handoverControl.ids.title + '-edit'">{{
            handoverCanAssign ? '' : 'Requires edit access'
          }}</span>
        </app-button2>
      }
      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-share"
        matTooltip="Share"
        [disabled]="!message?.id"
        [stchShareContextMenu]="message"
        [stchShareContextMenuDisabled]="!message?.id"
      />

      <app-button
        appearance="sapphire-secondary-ghost"
        size="xs"
        icon="sapphire-ellipsis"
        matTooltip="More options"
        [disabled]="!message?.id"
        (appMessageContextMenuTab)="$event === 'access' ? openWorkspaceAccess() : openItemComments()"
        [appMessageContextMenu]="message"
        appMessageContextMenuMode="popover"
        [appMessageContextMenuDisabled]="!message?.id"
        [printEnabled]="true"
        [appMessageContextMenuElementLocation]="UILocations.mainView"
      />

      @if (showCloseButton) {
        <app-button appearance="sapphire-secondary-ghost" size="xs" icon="sapphire-close" (click)="handleClose()" />
      }
    </div>
    <!-- Where the email is (its folder, or Inbox, Other Mail, Sent, Draft, Scheduled, Archive), as search and the
         Knowledge Hub badge it, on the To line under the header icons (Johanna, 2026-10-21). -->
    @if (headerBadge(); as badge) {
      <span class="mail-badge" [title]="'In ' + badge.label">
        <app-search-location-badge class="min-w-0" [type]="badge.type" [name]="badge.name" />
      </span>
    }
  </div>
</div>

<div class="subject">
  <!-- Display only: "[Draft]" before a draft's subject, "No subject" when there is none (the stored subject is
       untouched; Johanna, 2026-10-21). -->
  <div class="subject-input">
    @if (isDraft()) {
      <span class="subject-draft">[Draft]</span>
    }
    @if (message.title) {
      {{ message.title }}
    } @else {
      <span class="subject-empty">No subject</span>
    }
  </div>
  <!-- Grouped with the date rather than dropped in as a third child: `.subject` is space-between, so a
       bare team label would sit in the middle instead of at the right edge with the rest of the meta. -->
  <div class="flex items-center gap-2">
    <ng-container *ngComponentOutlet="workspaceComponents['app-item-team-label']; inputs: workspaceLabelInputs" />
    <div class="subject-date">{{ message.date | dateFormat: 'dateTime' }}</div>
  </div>
</div>

<div class="tabs">
  <app-tabs
    appearance="sapphire"
    [values]="workspaceTabs"
    [(value)]="selectedTab"
    [overflow]="insideModal() || dp || contracted ? 'dropdown' : 'scroll'"
    size="m"
  />

  <div class="filler"></div>

  <stch-knowledge-button class="print:hidden" [active]="displayKnowledge" (click)="showKnowledge()" />
</div>
@if (handoverTenantId) {
  <div class="mx-8 my-2 flex flex-wrap gap-x-8 gap-y-1 text-variant-sm text-subdued">
    <div>
      Responsible:
      <span data-testid="details-responsible">{{ handoverControl.responsibleName() }}</span>
    </div>
    @if (handoverControl.creatorName(); as author) {
      <div>
        Created by:
        <span data-testid="details-authored-by">{{ author }}</span>
      </div>
    }
  </div>
}

<app-item-handover
  #handoverControl
  [api]="handoverApi"
  [enabled]="!!handoverTenantId"
  [showButton]="false"
  [itemId]="handoverItemId"
  [tenantId]="handoverTenantId"
  [insideModal]="insideModal()"
  [matchItemSignals]="true"
  [stitchType]="StitchType.MESSAGE"
  [prototypeWindow]="true"
  noun="message"
/>
<app-item-review
  [api]="reviewApi"
  [enabled]="!!handoverTenantId"
  [itemId]="handoverItemId"
  [tenantId]="handoverTenantId"
  [insideModal]="insideModal()"
  [stitchType]="StitchType.MESSAGE"
  [contentVersion]="reviewContentVersion()"
/>

<div
  class="form"
  appDroppable
  appDroppableHoverClass="drag-over"
  [appDroppableDisabled]="!stitchItem?.id"
  [appDroppablePredicate]="dndPredicate"
  (appDroppableDrop)="dndDrop($event)"
>
  <div class="drop-area-border"></div>

  @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
    <app-entity-hub-search [contactId]="message?.id" />
  }

  <div class="form-heading">
    <div class="form-heading-nav">
      <div class="form-heading-nav-separator"></div>

    </div>

    <div *ngIf="displayKnowledge" class="form-heading-nav-underline"></div>

    <!-- One Knowledge box, rows in the skin's order: Knots · Tags · Connections. -->
    <div class="form-knowledge" [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())">
      <app-knots
        *ngIf="message"
        class="form-knots"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="message | toArray"
        [stateKey]="StateKey.knotsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="message?.id"
      />

      <app-tags
        *ngIf="message"
        class="form-tags"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="[message]"
        [stateKey]="StateKey.tagsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="message?.id"
      />

      <app-connections
        class="form-knots"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="[message]"
        [stateKey]="StateKey.connectionsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="message?.id"
      />
    </div>
  </div>

  @if (selectedTab === 'message' && message.otherMail) {
    <div class="mx-8 mb-4 rounded-lg border border-border px-8 py-4 text-variant-sm text-subdued">
      Routed to Other Mail because the sender does not match your current Mail Volume setting.
    </div>
  }

  @if (selectedTab === 'message' && message?.eventRemoteUid) {
    <!-- 16px under the Knowledge box, whose line it touched (Johanna, 2026-10-22). -->
    <app-mail-invitation-card
      class="mt-8 block"
      [mailboxTenantId]="message?.accountId"
      [eventRemoteUid]="message?.eventRemoteUid ?? null"
      [eventMethod]="message?.eventMethod ?? null"
    />
  }

  <stch-mail-body
    [message]="message"
    [senderAddress]="message?.from?.address"
    class="h-full overflow-hidden"
    *ngIf="selectedTab === 'message' && message?.bodyHtml"
    [body]="message?.bodyHtml"
    [highlights]="highlights()"
    (onImagesLoaded)="onLoadImages($event)"
  />

  <app-scroll
    *ngIf="(selectedTab !== 'stitch' || (permissionsLoaded() && !hasKnowledgeHubAccess()))"
    [ngSwitch]="selectedTab"
    class="form-scroll"
    (top)="displayScrollShadow = !$event"
  >
    <div *ngIf="displayScrollShadow" class="form-scroll-shadow"></div>

    <div *ngSwitchCase="'debug'" class="form-details">
      <stch-json-viewer [json]="message?.debug" />
    </div>

    <app-attachments
      *ngSwitchCase="'attachments'"
      class="form-attachments"
      [stitchItem]="message"
      [requestContext]="requestContext"
      (clickStitchItem)="handleClickItem($event)"
      (dblClickStitchItem)="handleDblClickItem($event)"
    />

    <app-context-menu-state-indicator
      *ngSwitchCase="'stitch'"
      class="block ml-auto w-fit mt-5 mr-4"
      svgIcon="filters"
      appStitchListContextMenu
      (appStitchListContextMenuChange)="stitchListState = $event"
    />

    <app-linked-info-list
      *ngSwitchCase="'stitch'"
      class="form-linked-info"
      [stitch]="message"
      [state]="stitchListState"
      (clickStitchItem)="handleClickItem($event)"
      (dblClickStitchItem)="handleDblClickItem($event)"
    />

    <div *ngSwitchCase="'access'" class="form-linked-info">
      <ng-container
        *ngComponentOutlet="workspaceComponents['app-item-workspace-access']; inputs: workspaceAccessInputs"
      />
    </div>

    <stch-comments
      (countChanged)="commentsCount.set($event)"
      [insideTeam]="insideTeam"
      *ngSwitchCase="'comments'"
      class="form-linked-info"
      [stitch]="message"
    />

    <ng-container *ngSwitchCase="'activity'">
      @if (itemChangesInputs; as inputs) {
        <ng-container *ngComponentOutlet="workspaceComponents['app-item-changes']; inputs: inputs" />
      }
    </ng-container>
  </app-scroll>

  @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
    <app-stitch-hub
      [stitch]="message"
      (clickStitchItem)="handleClickItem($event)"
      (dblClickStitchItem)="handleDblClickItem($event)"
    />
  }

  <stch-save-cancel-panel [enabled]="!pristine" (onCancel)="handleCancel()" (onSave)="handleSubmit()" />

  @if (isScheduled()) {
    <div
      class="h-24 absolute bottom-0 left-0 right-0 bg-background z-50 flex justify-start items-center border-t border-border"
    >
      <div class="ml-8">
        <app-button2 appearance="primary" size="s" (click)="cancelSchedule()"> Cancel Schedule </app-button2>
      </div>
      <div class="ml-4 text-sm text-secondary">
        Scheduled for {{ scheduledSendTimeValue() | dateFormat: 'dateTime' }}
      </div>
    </div>
  }

</div>

<ng-template #dragPlaceholder>
  <app-message [item]="message" [dragEnabled]="false" [draggable]="true" [actionsButtonEnabled]="false" />
</ng-template>

<ng-container *ngComponentOutlet="workspaceComponents['app-item-quick-comment']; inputs: quickCommentInputs" />

<!-- stitch-app-shell breadcrumbs footer in the main view, as in every app; elsewhere the workspace footer. -->
@if (navigation.enabled && message.id) {
  <app-detail-breadcrumbs
    [crumbs]="breadcrumbs()"
    [status]="form.controls.archived.value ? 'Archived' : form.controls.deleted.value ? 'Trash' : undefined"
  />
} @else {
  <ng-container *ngComponentOutlet="workspaceComponents['app-item-workspace-footer']; inputs: workspaceFooterInputs" />
}
